import { useEffect, useState } from 'react';
import { changeURLParams } from './url';
import { useRouter } from './useRouter';

// if sortFieldName is null then dont change the urls
export const useSortChanger = (sortFieldName, defaultSort, pageChangeType = 'replace') => {
  const router = useRouter();
  const { query } = router;
  const querySort = query[sortFieldName] || defaultSort;
  const [sort, setSort] = useState(querySort || defaultSort);

  useEffect(() => {
    if (sortFieldName && querySort !== sort) setSort(querySort);
  }, [querySort, sort]);

  const changeSortManualURLModification = (sort) => {
    if (querySort !== sort) {
      setSort(sort);
      return { [sortFieldName]: sort };
    } else return {};
  };

  const handleSortChange = (sort) => {
    if (sortFieldName) changeURLParams(router, changeSortManualURLModification(sort), { type: pageChangeType });
    else setSort(sort);
  };

  return {
    sort: sortFieldName ? querySort : sort,
    handleSortChange,
    changeSortManualURLModification,
  };
};
